module.exports = __webpack_public_path__ + "img/email.f6844b85.svg";